import { Stack, Typography } from "@mui/material";
import { prefixClassName } from "@smartrr/shared/components/primitives";
import { typedLocalize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export const OrderHistoryShippingMethod = ({ deliveryMethodTitle }: { deliveryMethodTitle?: string }) => {
  if (!deliveryMethodTitle) {
    return;
  }

  return (
    <Stack direction="row" justifyContent="space-between" className={prefixClassName("shipping-method-line")}>
      <Typography variant="body2" whiteSpace="nowrap">
        {typedLocalize("orderHistory.shippingMethod")}
      </Typography>
      <Typography variant="body1" sx={{ textAlign: "right" }}>
        {deliveryMethodTitle}
      </Typography>
    </Stack>
  );
};
